import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-vendor-list',
  templateUrl: './vendor-list.component.html',
  styleUrls: ['./vendor-list.component.css']
})
export class VendorListComponent implements OnInit {

  cid:any
  vendorList:any = []
  sigleVendorData:any = []

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  isLoading = false
  first: number = 0;
  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  vendorForm: any | FormGroup
  formSubmit: boolean = false;

  documents:any = []
  geoAddress:any = {
    "slNo": "",
    "name": "",
    "phone1": "",
    "phone2": "",
    "email": "",
    "latitude": "",
    "longitude": "",
    "address": "",
    "postCode": "",
    "isDefault": true,
    "type": "",
    "state": "",
    "landmark": "",
    "city": "",
    "town": "",
    "district": ""
  }
  keyValueList:any = []
  deleteId: any
  recordId: any = "";
  recordName: any ="";

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllVendor(this.pageNumber,this.recordsPerPage)

    this.vendorForm = this.fb.group({
      name: [''],
      code: [''],
      image: [''],
      type: [''],
      contactPhone: [''],
      contactEmail: [''],
      contactName: [''],
      description: ['']
    })
    this.predefinedParameter()
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.getAllVendor(this.pageNumber,this.recordsPerPage)
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeAdd")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllVendor(pageNumber:any,recordsPerPage:any){
    this.isLoading = true
    this.generic_service.getVendor(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response)
        this.vendorList = response.response.vendorMasterList;
        this.totalRecords = response.response.totalRecords;
        this.isLoading = false

      }
    )
  }

  getVendorById(vendorMasterId:any){
    this.generic_service.getVendorById(vendorMasterId).subscribe(
      (response:any)=>{
        console.log(response)
        this.sigleVendorData = []
        this.sigleVendorData.push(response.response)
      }
    )
  }

  rejectVendor(){
    let body = {
      "userId": sessionStorage.getItem("userId"),
      "vendorMasterStatus": "REJECTED",
      "updatedDate": new Date().getTime(),
      "note": ""
    }
    console.log(body)
  
    this.generic_service.updateVendorStatus(this.sigleVendorData[0].vendorMasterId,body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllVendor(this.pageNumber-1,this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  approveVendor(){
    let body = {
      "userId": sessionStorage.getItem("userId"),
      "vendorMasterStatus": "APPROVED",
      "updatedDate": new Date().getTime(),
      "note": ""
    }
    console.log(body)
  
    this.generic_service.updateVendorStatus(this.sigleVendorData[0].vendorMasterId,body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllVendor(this.pageNumber-1,this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  imageButtonClick(){
    document.getElementById("imageInput")?.click()
  }

  onChange(event: any) {
    this.onUpload(event.target.files[0])
  }

  onUpload(file: any) {
    this.generic_service.uploadImage(file).subscribe(
      (event: any) => {
        this.vendorForm.patchValue({image: event.response});
      }
    );
  }

  imageRemove(){
    this.vendorForm.patchValue({image: ""})
  }

  docButtonClick(){
    document.getElementById("DocInput")?.click()
  }

  onChangeDoc(event: any) {
    console.log(event)
    this.onUploadDoc(event.target.files[0])
  }

  onUploadDoc(file: any) {
    console.log(file)
    let obj:any = {
      "name": file.name,
      "type": file.type,
      "url": ""
    }
    console.log(obj)
    this.generic_service.uploadImage(file).subscribe(
      (event: any) => {
        obj.url = event.response;
        this.documents.push(obj)
        console.log(this.documents)

      }
    );
  }

  predefinedParameter(){
    this.generic_service.predefinedParameter('VENDOR').subscribe(
      (response:any)=>{
        console.log(response)
        for(let i=0; i<response.response.length; i++){
          this.keyValueList.push(
            {
              boxType: response.response[i].boxType,
              key: response.response[i].name,
              possibleValue: response.response[i].possibleValue,
              value: ""
            }
          )
        }
        console.log(this.keyValueList)
      },
      (err:any)=>{
          console.log(err)
      }
    )
  }

  // get documentArray(){
  //   return this.vendorForm.get('documents') as FormArray;
  // }

  // addDocumentArray(){
  //   let arr = this.fb.group({
  //     name: [''],
  //     type: [''],
  //     url: [''],
  //   })
  //   this.documentArray.push(arr)
  // }

  addVendor(){
    this.formSubmit = true;
    // if(!this.vendorForm.valid){
    //   return
    // }

    for(var i = 0; i < this.keyValueList.length; i++){
      delete this.keyValueList[i].boxType
      delete this.keyValueList[i].possibleValue
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": this.vendorForm.get('description').value,
      "vendorMasterId": 0,
      "code": this.vendorForm.get('code').value,
      "name": this.vendorForm.get('name').value,
      "contactPhone": this.vendorForm.get('contactPhone').value,
      "contactEmail": this.vendorForm.get('contactEmail').value,
      "contactName": this.vendorForm.get('contactName').value,
      "documents": this.documents,
      "image": this.vendorForm.get('image').value,
      "keyValueList": this.keyValueList,
      "geoAddress": this.geoAddress,
      "statusList": [
        {
          "userId": 0,
          "vendorMasterStatus": "APPLIED",
          "updatedDate": 0,
          "note": ""
        }
      ],
      "latestStatus": "APPLIED",
      "latestStatusDate": 0,
      "size": "",
      "type": this.vendorForm.get('type').value,
      "cid": 0
    }
    console.log(body)
    this.generic_service.addVendor(body).subscribe(
      (response:any)=>{
        this.formSubmit = false;
        this.cancelModel()
        this.getAllVendor(this.pageNumber,this.recordsPerPage)
        this.vendorForm.reset()
        this.vendorForm.patchValue({image: ""})
        this.predefinedParameter()
        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }


  deleleVendor(){
    this.generic_service.delVendor(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success("Successfully Deleted");
        this.getAllVendor(this.pageNumber,this.recordsPerPage)
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  deleteIdSelect(id:any,list: any){
    this.deleteId = id
    this.recordId = list.vendorMasterId
    this.recordName = list.name
  }

  del(id:any){
    this.deleteId = id
  }


  refreshSearch(){
    this.searchKey = ""
    this.getAllVendor(this.pageNumber,this.recordsPerPage)
  }

  searchKey: any = ""

  getVendorByWildSearch(pageNumber: any,recordsPerPage: any){
    console.log(this.searchKey)
    if(this.searchKey != ""){
      this.isLoading = true

      this.generic_service.getVendorByWildSearch(this.searchKey,pageNumber,recordsPerPage).subscribe(
        (response:any)=>{
          console.log(response);
          this.vendorList = response.response.vendorMasterList;
          this.totalRecords = response.response.totalRecords;
          this.isLoading = false

        },
        (err:any)=>{
          console.log(err)
        }
      )
    }else{
      this.getAllVendor(this.pageNumber,this.recordsPerPage)
    }
  }


  refreshAll(){
    this.pageNumber = 0
    this.searchKey = ""
    this.getAllVendor(this.pageNumber,this.recordsPerPage)
  }

}

